import { colors } from 'fitify-ui/src/theme/colors'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  /*
  http://meyerweb.com/eric/tools/css/reset/
  v2.0 | 20110126
  License: none (public domain)
  */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    padding: 0;
    border: 0;
    margin: 0;
    font: inherit;
    -webkit-tap-highlight-color: transparent;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    -webkit-font-smoothing: antialiased;
    line-height: 1;
    scroll-behavior: smooth;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote::before, blockquote::after,
  q::before, q::after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    background: ${colors.Mantis100};
    color: ${colors.Black};
    font-family: "Graphik LCG Web", "Helvetica Neue", sans-serif;
    scroll-behavior: smooth;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }

  @keyframes react-loading-skeleton {
    100% {
      transform: translateX(100%);
    }
  }

  .react-loading-skeleton {
    --base-color: #ebebeb;
    --highlight-color: #f5f5f5;
    --animation-duration: 1.5s;
    --animation-direction: normal;
    --pseudo-element-display: block; /* Enable animation */

    position: relative;
    z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */
    display: inline-flex;
    overflow: hidden;
    width: 100%;
    border-radius: 0.25rem;
    background-color: var(--base-color);
    line-height: 1;
  }

  .react-loading-skeleton::after {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    display: var(--pseudo-element-display);
    height: 100%;
    animation-direction: var(--animation-direction);
    animation-duration: var(--animation-duration);
    animation-iteration-count: infinite;
    animation-name: react-loading-skeleton;
    animation-timing-function: ease-in-out;
    background-image: linear-gradient(
      90deg,
      var(--base-color),
      var(--highlight-color),
      var(--base-color)
    );
    background-repeat: no-repeat;
    content: ' ';
    transform: translateX(-100%);
  }
`
